import { render, staticRenderFns } from "./workerWageDetail.vue?vue&type=template&id=1e65888f&scoped=true&"
import script from "./workerWageDetail.vue?vue&type=script&lang=js&"
export * from "./workerWageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65888f",
  null
  
)

export default component.exports